export class ErpRoutes
{
    static Home: string = "/";

    // Currency
    static CurrencyList: string = "/currency/list";
    static CurrencyNew: string = "/currency/new";
    static CurrencyView(id: string) { return `/currency/${id}/view`; }
    static CurrencyEdit(id: string) { return `/currency/${id}/edit`; }
    static CurrencyCopy(id: string) { return `/currency/${id}/copy`; }

    // Currency Exchange
    static CurrencyExchangeList: string = "/currency/exchange/list";
    static CurrencyExchangeNew: string = "/currency/exchange/new";
    static CurrencyExchangeView(id: string) { return `/currency/exchange/${id}/view`; }
    static CurrencyExchangeEdit(id: string) { return `/currency/exchange/${id}/edit`; }
    static CurrencyExchangeCopy(id: string) { return `/currency/exchange/${id}/copy`; }

    // Company
    static CompanyList: string = "/company/list";
    static CompanyNew: string = "/company/new";
    static CompanyView(id: string) { return `/company/${id}/view`; }
    static CompanyEdit(id: string) { return `/company/${id}/edit`; }
    static CompanyCopy(id: string) { return `/company/${id}/copy`; }

    // Branch
    static BranchList: string = "/branch/list";
    static BranchNew: string = "/branch/new";
    static BranchView(id: string) { return `/branch/${id}/view`; }
    static BranchEdit(id: string) { return `/branch/${id}/edit`; }
    static BranchCopy(id: string) { return `/branch/${id}/copy`; }

    // Fiscal Year
    static FiscalYearList: string = "/fiscal/year/list";
    static FiscalYearNew: string = "/fiscal/year/new";
    static FiscalYearView(id: string) { return `/fiscal/year/${id}/view`; }
    static FiscalYearEdit(id: string) { return `/fiscal/year/${id}/edit`; }
    static FiscalYearCopy(id: string) { return `/fiscal/year/${id}/copy`; }

    // Account
    static AccountList: string = "/account/list";
    static AccountNew: string = "/account/new";
    static AccountView(id: string) { return `/account/${id}/view`; }
    static AccountEdit(id: string) { return `/account/${id}/edit`; }
    static AccountCopy(id: string) { return `/account/${id}/copy`; }

    // Party Type
    static PartyTypeList: string = "/party/type/list";
    static PartyTypeNew: string = "/party/type/new";
    static PartyTypeView(id: string) { return `/party/type/${id}/view`; }
    static PartyTypeEdit(id: string) { return `/party/type/${id}/edit`; }
    static PartyTypeCopy(id: string) { return `/party/type/${id}/copy`; }

    // Party
    static PartyList: string = "/party/list";
    static PartyNew: string = "/party/new";
    static PartyView(id: string) { return `/party/${id}/view`; }
    static PartyEdit(id: string) { return `/party/${id}/edit`; }
    static PartyCopy(id: string) { return `/party/${id}/copy`; }

    // Tag Group
    static TagGroupList: string = "/tag/group/list";
    static TagGroupNew: string = "/tag/group/new";
    static TagGroupView(id: string) { return `/tag/group/${id}/view`; }
    static TagGroupEdit(id: string) { return `/tag/group/${id}/edit`; }
    static TagGroupCopy(id: string) { return `/tag/group/${id}/copy`; }

    // Tag
    static TagList: string = "/tag/list";
    static TagNew: string = "/tag/new";
    static TagView(id: string) { return `/tag/${id}/view`; }
    static TagEdit(id: string) { return `/tag/${id}/edit`; }
    static TagCopy(id: string) { return `/tag/${id}/copy`; }

    // Lock
    static LockList: string = "/lock/list";
    static LockNew: string = "/lock/new";
    static LockView(id: string) { return `/lock/${id}/view`; }
    static LockEdit(id: string) { return `/lock/${id}/edit`; }
    static LockCopy(id: string) { return `/lock/${id}/copy`; }

    // Journal Entry
    static JournalEntryList: string = "/journal/entry/list";
    static JournalEntryNew: string = "/journal/entry/new";
    static JournalEntryView(id: string) { return `/journal/entry/${id}/view`; }
    static JournalEntryEdit(id: string) { return `/journal/entry/${id}/edit`; }
    static JournalEntryCopy(id: string) { return `/journal/entry/${id}/copy`; }

    // Journal Entry Request (change requests that need the owner's approval)
    static JournalEntryRequestNew: string = "/journal/entry/request/new";
    static JournalEntryRequestEdit(id: string) { return `/journal/entry/request/${id}/edit`; }
    static JournalEntryRequestCopy(id: string) { return `/journal/entry/request/${id}/copy`; }

    // Vehicle
    static VehicleList: string = "/vehicle/list";
    static VehicleNew: string = "/vehicle/new";
    static VehicleView(id: string) { return `/vehicle/${id}/view`; }
    static VehicleEdit(id: string) { return `/vehicle/${id}/edit`; }
    static VehicleCopy(id: string) { return `/vehicle/${id}/copy`; }

    // Service Type
    static ServiceTypeList: string = "/service/type/list";
    static ServiceTypeNew: string = "/service/type/new";
    static ServiceTypeView(id: string) { return `/service/type/${id}/view`; }
    static ServiceTypeEdit(id: string) { return `/service/type/${id}/edit`; }
    static ServiceTypeCopy(id: string) { return `/service/type/${id}/copy`; }

    // Maintenance Plan
    static MaintenancePlanList: string = "/maintenance/plan/list";
    static MaintenancePlanNew: string = "/maintenance/plan/new";
    static MaintenancePlanView(id: string) { return `/maintenance/plan/${id}/view`; }
    static MaintenancePlanEdit(id: string) { return `/maintenance/plan/${id}/edit`; }
    static MaintenancePlanCopy(id: string) { return `/maintenance/plan/${id}/copy`; }

    // Service
    static ServiceList: string = "/service/list";
    static ServiceNew: string = "/service/new";
    static ServiceView(id: string) { return `/service/${id}/view`; }
    static ServiceEdit(id: string) { return `/service/${id}/edit`; }
    static ServiceCopy(id: string) { return `/service/${id}/copy`; }

    // Odometer
    static OdometerList: string = "/odometer/list";
    static OdometerNew: string = "/odometer/new";
    static OdometerView(id: string) { return `/odometer/${id}/view`; }
    static OdometerEdit(id: string) { return `/odometer/${id}/edit`; }
    static OdometerCopy(id: string) { return `/odometer/${id}/copy`; }

    // Fuel
    static FuelList: string = "/fuel/list";
    static FuelNew: string = "/fuel/new";
    static FuelView(id: string) { return `/fuel/${id}/view`; }
    static FuelEdit(id: string) { return `/fuel/${id}/edit`; }
    static FuelCopy(id: string) { return `/fuel/${id}/copy`; }

    // Refueling
    static RefuelingList: string = "/refueling/list";
    static RefuelingNew: string = "/refueling/new";
    static RefuelingView(id: string) { return `/refueling/${id}/view`; }
    static RefuelingEdit(id: string) { return `/refueling/${id}/edit`; }
    static RefuelingCopy(id: string) { return `/refueling/${id}/copy`; }

    // GIFI (Canadian CRA RC4088 reference data)
    static GifiList: string = "/gifi/list";
    static GifiView(code: string) { return `/gifi/${code}/view`; }

    // Reports
    static ReportGeneralLedger: string = "/report/general-ledger";
    static ReportBalanceSheet: string = "/report/balance-sheet";
    static ReportGifi: string = "/report/gifi";
    static ReportJournalEntryRequest: string = "/report/journal-entry-request";
}